/** @jsxImportSource @emotion/react */
import Panels from 'src/components/Panel/Panels';
import PaymentsListPanel from './PaymentsListPanel';

export default function Payments() {
  return <Panels main={PaymentsListPanel} />;
}
